import { FInsertFavoriteToDayplanConnectorApollo } from '@front-activerse/common-components';
import { FAddMealToFavoritesConnectorApollo } from '@front-activerse/common-components';
import { FRemoveMealFromFavoritesConnectorApollo } from '@front-activerse/common-components';
import { FFavMealDetailsConnectorApollo } from '@front-activerse/common-components';
import { RateMealConnectorApollo } from '@front-activerse/common-components';
import FavMealContainer from './FavMealContainer';
import { useTimestamp } from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

const FavMealPage = () => {
  const { timestamp1 } = useTimestamp();
  const { mealId } = useParams();

  return (
    <FFavMealDetailsConnectorApollo mealId={+mealId}>
      {({ cacheHit, hasNetworkError, lastAvailableDay, ...favMealData }) => (
        <RateMealConnectorApollo>
          {({ rateMeal }) => (
            <FRemoveMealFromFavoritesConnectorApollo>
              {({ removeMealFromFavorites }) => (
                <FAddMealToFavoritesConnectorApollo>
                  {({ addMealToFavorites }) => (
                    <FInsertFavoriteToDayplanConnectorApollo>
                      {({ insertFavoriteToDayplan }) => {
                        if (favMealData.loading) {
                          return <UniversalPlaceholder />;
                        }

                        // to prevent crash app after clear cache object and mount again fav meal details component
                        if (!favMealData.favMeal) {
                          favMealData.refetch(+mealId);
                          return <UniversalPlaceholder />;
                        }

                        return (
                          <FavMealContainer
                            key={timestamp1}
                            lastAvailableDay={lastAvailableDay}
                            {...favMealData}
                            {...{
                              removeMealFromFavorites,
                            }}
                            {...{
                              addMealToFavorites,
                            }}
                            {...{
                              insertFavoriteToDayplan,
                            }}
                            rateMeal={rateMeal}
                          />
                        );
                      }}
                    </FInsertFavoriteToDayplanConnectorApollo>
                  )}
                </FAddMealToFavoritesConnectorApollo>
              )}
            </FRemoveMealFromFavoritesConnectorApollo>
          )}
        </RateMealConnectorApollo>
      )}
    </FFavMealDetailsConnectorApollo>
  );
};

export default FavMealPage;
